import React, { useEffect, useState } from 'react';
import { MonitorSmartphone, LogOut, Loader2 } from 'lucide-react';
import { carsysApi } from '../api/carsysApi';
import { getDeviceId } from '../lib/device';
import { useT } from '../context/LanguageContext';
import { toast } from 'sonner';

// Toont de actieve apparaten van deze garage met de mogelijkheid ze zelf af te melden.
export default function DevicesPanel() {
  const { t } = useT();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState('');
  const mine = getDeviceId();

  const load = () => carsysApi.getDevices().then(setData).catch(() => setData({ devices: [], limit: null }));
  useEffect(() => { load(); }, []);

  const release = async (deviceId) => {
    setBusy(deviceId);
    try { await carsysApi.deleteDevice(deviceId); toast.success(t('Apparaat afgemeld', 'Apparaat afgemeld')); load(); }
    catch (e) { toast.error(t('Mislukt'), { description: e.response?.data?.detail || e.message }); }
    finally { setBusy(''); }
  };

  if (!data) return null;
  const devices = data.devices || [];

  return (
    <div style={{ marginTop: 18, paddingTop: 16, borderTop: '1px solid var(--cs-border)' }} data-testid="devices-panel">
      <label className="cs-section-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <MonitorSmartphone size={15} /> {t('Actieve apparaten', 'Actieve apparaten')} ({devices.length}{data.limit ? ` / ${data.limit}` : ''})
      </label>
      <p style={{ fontSize: 12, color: 'var(--cs-text-muted)', margin: '2px 0 10px' }}>
        {t('Apparaten die 90 dagen niet zijn gebruikt worden automatisch verwijderd.', 'Apparaten die 90 dagen niet zijn gebruikt worden automatisch verwijderd.')}
      </p>
      {devices.length === 0 ? (
        <div className="cs-empty">{t('Nog geen geregistreerde apparaten.', 'Nog geen geregistreerde apparaten.')}</div>
      ) : (
        <div style={{ display: 'grid', gap: 8 }}>
          {devices.map(d => (
            <div key={d.deviceId} data-testid={`mydevice-${d.deviceId}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '10px 12px', background: 'var(--cs-card-alt)', borderRadius: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                <MonitorSmartphone size={17} style={{ color: 'var(--cs-text-muted)', flexShrink: 0 }} />
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>
                    {d.deviceName || t('Onbekend apparaat', 'Onbekend apparaat')}
                    {d.deviceId === mine && <span className="cs-badge green" style={{ marginLeft: 6, fontSize: 10 }}>{t('dit apparaat', 'dit apparaat')}</span>}
                  </div>
                  <div style={{ fontSize: 11.5, color: 'var(--cs-text-muted)' }}>
                    {d.ip || '?'} · {t('laatst actief', 'laatst actief')} {d.lastSeen ? new Date(d.lastSeen).toLocaleString('nl-NL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—'}
                  </div>
                </div>
              </div>
              <button data-testid={`mydevice-release-${d.deviceId}`} className="cs-btn ghost danger" onClick={() => release(d.deviceId)} disabled={busy === d.deviceId} style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
                {busy === d.deviceId ? <Loader2 size={12} className="spin" /> : <LogOut size={12} />} {t('Afmelden', 'Afmelden')}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
